import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryShortcuts from '@/pages/home/components/CategoryShortcuts';
import PopularSection from '@/pages/home/components/PopularSection';
import { getFeaturedMovies, getPopularMovies } from '@/utils/movieQuery';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

const HIGHLIGHTS = [
  { icon: 'ri-filter-3-line', title: '多维筛选', desc: '按年份、评分、时长精细筛选，快速锁定今晚想看的类型。' },
  { icon: 'ri-search-eye-line', title: '关键词检索', desc: '支持标题、简介、标签模糊搜索，输入一点点也能找到。' },
  { icon: 'ri-heart-3-line', title: '本地收藏', desc: '喜欢就收藏，收藏记录保存在你的浏览器，随时回顾。' },
  { icon: 'ri-information-line', title: '观影前参考', desc: '提供剧情简介与午夜看点，帮你判断今晚是否合口味。' },
];

export default function Home() {
  useDocumentTitle({
    title: '午夜小电影-精选午夜主题短片及影片推荐',
    description:
      '午夜小电影网站专注于精选各类午夜主题的短片和电影作品，涵盖剧情、悬疑、恐怖等多种类型，帮助用户发现优质午夜影视内容。',
    keywords: '午夜小电影,午夜短片,午夜电影,午夜影视推荐,悬疑电影,恐怖电影,午夜剧情片',
  });

  const featured = getFeaturedMovies().slice(0, 5);
  const popular = getPopularMovies(8);

  return (
    <div className="flex flex-col">
      <HeroCarousel movies={featured} />
      <CategoryShortcuts />
      <PopularSection movies={popular} />

      <section className="bg-background-50">
        <div className="mx-auto w-full px-4 py-14 md:px-8 md:py-20">
          <div className="mb-10 max-w-2xl">
            <p className="font-display text-sm tracking-[0.25em] text-primary-400">WHY US</p>
            <h2 className="mt-1 text-2xl text-foreground-950 md:text-3xl">为什么选择午夜小电影</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们不追求片库的数量，而是专注“午夜时刻”。每一部影片都经过挑选，并附带观看前介绍，
              让你在夜里的每一分钟都花得值。
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6 lg:grid-cols-4">
            {HIGHLIGHTS.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-300/50 bg-background-100 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-500/15 text-accent-500">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-5 text-base text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 flex flex-col items-start gap-5 rounded-lg border border-primary-500/30 bg-primary-500/10 p-8 md:flex-row md:items-center md:justify-between">
            <div>
              <h3 className="text-xl text-foreground-950">还没想好看什么？</h3>
              <p className="mt-2 text-sm text-foreground-600">直接从搜索开始，输入关键词，或让分类帮你在几秒内缩小范围。</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/search"
                className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-white transition hover:bg-primary-600"
              >
                <i className="ri-search-line"></i>去搜索
              </Link>
              <Link
                to="/about"
                className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 text-sm text-foreground-700 transition hover:text-foreground-950"
              >
                了解我们
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}